function buocGiaoDichCuaToi() {
  return [
    {
      target: "body",
      placement: "center",
      title: "Bước 1 · Giao dịch của tôi",
      content:
        "Trang này liệt kê phiếu thu mua bạn đã ghi (theo ngày), kèm bản nháp dở dang nếu có. Dùng để gửi về kế toán hoặc sửa phiếu chưa xong.",
    },
    {
      target: "#tour-giao-dich-cua-toi-bo-loc",
      title: "Bước 2 · Chọn ngày xem",
      content:
        'Đổi ngày ở đây để xem lại các phiếu thu mua đã ghi trong ngày đó. Nếu còn bản nháp thu mua chưa lưu thành giao dịch thật, nó hiện thành bảng riêng ngay phía trên bảng chính — bấm "Tiếp tục" để mở lại form đang dở, hoặc "Xoá" để bỏ nháp (có xác nhận 2 lần trước khi xoá hẳn).',
      placement: "bottom",
    },
    {
      target: "#tour-giao-dich-cua-toi-chi-so",
      title: "Bước 3 · Ba chỉ số trong ngày",
      content:
        "Tổng số phiếu thu mua, khối lượng đã cân và thành tiền — chỉ tính riêng ngày đang chọn ở bộ lọc trên, đổi ngày để xem lại ngày khác.",
      placement: "bottom",
    },
    {
      target: "#tour-giao-dich-cua-toi-bang",
      title: "Bước 4 · Xử lý từng phiếu",
      content:
        'Bấm vào một dòng để xem chi tiết phiếu — gồm từng loại bơ và trạng thái thanh toán (chờ xử lý / chờ kế toán / đang thanh toán / đã thanh toán). Nếu phiếu đang "chờ xử lý" sẽ có nút "Gửi về kế toán" hoặc "Sửa".',
      placement: "top",
    },
    {
      target: "#tour-giao-dich-cua-toi-bang",
      title: "Bước 5 · Khoá sau khi gửi kế toán",
      content:
        'Chỉ sửa/xoá được khi phiếu còn "chờ xử lý". Sau khi gửi kế toán (hoặc đã thanh toán) phiếu bị khoá — nếu kế toán trả lại kèm ghi chú, bạn sửa rồi gửi lại.',
      placement: "top",
    },
  ];
}

export default buocGiaoDichCuaToi;
